<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Media Object" pageTitle="Media Object" />
            <MediaObject />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import MediaObject from '../MediaObject/MediaObject'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'MediaObjectPage',
    components: {
        MainHeader,
        PageTitle,
        MediaObject,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>